import { render, staticRenderFns } from "./DialogSendInvite.vue?vue&type=template&id=7f087f65&scoped=true&"
import script from "./DialogSendInvite.vue?vue&type=script&lang=ts&"
export * from "./DialogSendInvite.vue?vue&type=script&lang=ts&"
import style0 from "./DialogSendInvite.vue?vue&type=style&index=0&id=7f087f65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f087f65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VForm,VImg,VRow})
